// extracted by mini-css-extract-plugin
module.exports = {"floatingBtnContainer":"CreatePostButton_floatingBtnContainer__3zcpi","addIcon":"CreatePostButton_addIcon__1hPxx"};